import { Component } from '@angular/core';

@Component({
  selector: 'page-about',
  templateUrl: 'about.html'
})
export class AboutPage {

  constructor() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/about/about.ts